import { render, staticRenderFns } from "./VideoNewUploadModal.vue?vue&type=template&id=137aa18d&scoped=true"
import script from "./VideoNewUploadModal.vue?vue&type=script&lang=js"
export * from "./VideoNewUploadModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137aa18d",
  null
  
)

export default component.exports